module.exports = __webpack_public_path__ + "static/media/techLead2.77a7b125.jpg";